module.exports = __webpack_public_path__ + "img/chev-left-dark.bd3e8eab.svg";